import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Footer.module.css';


const NAV_LINKS = [
  { to: '/',          label: 'Inicio' },
  { to: '/productos', label: 'Productos' },
  { to: '/clientes',  label: 'Clientes' },
  { to: '/blog',      label: 'Blog' },
  { to: '/contacto',  label: 'Contacto' },
];

const SOCIAL = [
  { href: 'https://wa.me/5491136112732',                    icon: '/Assets/icons/whatsapp.svg',  label: 'WhatsApp' },
  { href: 'https://www.instagram.com/microled_argentina',   icon: '/Assets/icons/Instagram.svg', label: 'Instagram' },
  { href: 'https://www.facebook.com/microled.argentina/',   icon: '/Assets/icons/Facebook.svg',  label: 'Facebook' },
];

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>

        {/* ── Marca ── */}
        <div className={styles.brand}>
          <img src="/Assets/Microled-Mati-Calvier.svg" alt="Microled Argentina" className={styles.logo} />
          <p className={styles.tagline}>
            Fábrica argentina de letreros electrónicos y pantallas LED.
            Más de 30&nbsp;años de experiencia.
          </p>
          <div className={styles.socialRow}>
            {SOCIAL.map(s => (
              <a key={s.label} href={s.href} target="_blank" rel="nofollow noreferrer"
                className={styles.socialBtn} aria-label={s.label} title={s.label}>
                <img src={s.icon} alt={s.label} />
              </a>
            ))}
          </div>
        </div>

        {/* ── Navegación ── */}
        <div className={styles.col}>
          <h3 className={styles.colTitle}>Navegación</h3>
          <ul className={styles.list}>
            {NAV_LINKS.map(l => (
              <li key={l.to}>
                <Link to={l.to} className={styles.navLink}>{l.label}</Link>
              </li>
            ))}
          </ul>
        </div>


      </div>

      {/* ── Barra inferior ── */}
      <div className={styles.bottom}>
        <span>© {new Date().getFullYear()} Cia de Manufactura y Mediciones SRL</span>
        <span className={styles.dot}>·</span>
        <span>Pichincha 188, C.A.B.A.</span>
      </div>
    </footer>
  );
}
